<div class="progress">
  <div class="progress-bar">
    <div class="bar"></div>
    <div class="info">
      <div class="title" appTranslate>Trwa wysyłanie dokumentu</div>
      <div class="message">{{ currentMessage | translate: currentLanguageCode | async }}</div>
    </div>
  </div>
</div>
